import {ref} from 'vue';
import {defineStore} from 'pinia';

import {TOAST_TYPES} from '@/core/constants/components/toastTypes';

const DEFAULT_TOAST_COUNT = 3;

export const useToastsStore = defineStore('toasts', () => {
    const toasts = ref([]);

    function success(message) {
        toasts.value = _setToast({toasts: toasts.value, message, type: TOAST_TYPES.SUCCESS});
    }

    function error(message) {
        toasts.value = _setToast({toasts: toasts.value, message, type: TOAST_TYPES.ERROR});
    }

    function warning(message) {
        toasts.value = _setToast({toasts: toasts.value, message, type: TOAST_TYPES.WARNING});
    }

    function info(message) {
        toasts.value = _setToast({toasts: toasts.value, message, type: TOAST_TYPES.INFO});
    }

    function removeToast(id) {
        toasts.value = toasts.value.filter((toast) => toast.id !== id);
    }

    return {
        toasts,
        success,
        error,
        warning,
        info,
        removeToast,
    };
});

function _setToast({toasts, message, type}) {
    if (toasts?.length > DEFAULT_TOAST_COUNT) {
        return [];
    }

    const isToastExist = !!toasts?.find((toast) => toast.message === message);

    if (isToastExist) {
        return [];
    }

    const id = Date.now();

    return [...toasts, {message, type, id}];
}
